module.exports = __webpack_public_path__ + "static/img/Brewery.1f13c3f.png";